import { render, staticRenderFns } from "./PercentageField.vue?vue&type=template&id=090e20e9"
import script from "./PercentageField.vue?vue&type=script&lang=ts"
export * from "./PercentageField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports